import { render, staticRenderFns } from "./DecimalComponent.vue?vue&type=template&id=55036890&scoped=true&"
import script from "./DecimalComponent.vue?vue&type=script&lang=js&"
export * from "./DecimalComponent.vue?vue&type=script&lang=js&"
import style0 from "./DecimalComponent.vue?vue&type=style&index=0&id=55036890&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55036890",
  null
  
)

export default component.exports